export const MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];

export const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

export const REF_FORMS = 'refForms';
export const REF_OFFICE = 'refOffices';
export const REF_CALENDAR = 'refCalendar';
export const REF_SLOT = 'refOfficeSlot';
